import React from 'react';

/*
    - ihoDesignSystem
*/
import { Box, Image } from '@iho-design-system/Loader';

/*
    - icons
*/
import LogoSVG from '../../assets/images/help-desk/logo.svg';
import DashSVG from '../../assets/images/help-desk/dash.svg';
import homeSVG from '../../assets/images/help-desk/home.svg';

const ChatBoxHeader = ({ requestType, toggleHelpDeskProps, toggleTabProps }) => {

    return (

        <React.Fragment>

            <Box
                className='d-flex align-item-center justify-content-between p-xl border-solid-bottom border-medium'>
                <Box
                    className={`d-flex`}>
                    <Image
                        onClick={toggleHelpDeskProps}
                        className={`pointer`}
                        src={DashSVG}
                        alt='logo'
                        ms={{
                            width: '24px',
                            height: 'auto'
                        }} />
                    {requestType.split(',')[0] === 'newRequest' &&
                        <Image
                            onClick={() => toggleTabProps('home')}
                            className={`pointer mx-xl ml-0`}
                            src={homeSVG}
                            alt='home'
                            ms={{
                                width: '24px',
                                height: 'auto'
                            }} />
                    }
                </Box>
                <Box>
                    <Image
                        src={LogoSVG}
                        alt='logo'
                        ms={{
                            width: '120px',
                            height: 'auto'
                        }} />
                </Box>
            </Box>

        </React.Fragment>

    );

}

export default ChatBoxHeader;